<template>
  <v-app>
    <v-content class="d-flex justify-center align-center mx-auto">
      <div class="d-flex flex-column align-center" style="max-width: 40vw">
        <img :src="statusImg" class="status-img mb-5"/>

        <div class="font-weight-bold text--red headline mb-0">Payment Failed</div>
        <div v-if="$route.query.ebpNo" class="font-weight-medium blue-grey--text text--darken-3 subtitle-1">
          Payment Failed for voucher:
          <b class="ml-1">{{ $route.query.ebpNo }}</b>
        </div>

        <v-alert :value="true" class="hide-on-print text-black mt-4" type="error" outlined>
          Dear user, We are unable to proceed at current time. If your amount has been debited from current account.
          Please mail at <b> info@immigration.gov.np </b> or call at <b>+977-01-4429659</b>
        </v-alert>
        <v-btn color="primary" large dressed @click="moveToApplyAgain" class="my-4">Apply again</v-btn>

        <div class="d-flex align-center mt-5">
          <img :src="logoUrl" alt="avatar" class="mr-5" style="width: 300px">
          <img :src="sarkarLogo" alt="avatar" style="width: 100px;">
        </div>
      </div>

    </v-content>
  </v-app>
</template>

<script>
import {NEPAL_SARKAR_LOGO, NEPALIPORT_LOGO_URL} from "@/constant/appConstant";

export default {
  name: "GovPayFailure",
  data() {
    return {
      sarkarLogo: NEPAL_SARKAR_LOGO,
      logoUrl: NEPALIPORT_LOGO_URL,
      statusImg: require('@/assets/error.png')
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name && (from.name === 'OnArrival' || from.name === 'OnlineApplication' || from.name === 'OnArrival')) {
      next(vm => {
        vm.$router.push({
          name: 'OnlineApplication'
        })
      })
    }
    next();
  },
  methods: {
    moveToApplyAgain(){
      let routeData = this.$router.resolve({name: 'HomePage'});
      window.open(routeData.href, '_self');
      // this.$router.push({name: 'HomePage'});
    },
  }
}
</script>

<style scoped>
.status-img {
  height: 200px;
}

</style>



